import { Badge, type BadgeTone, type IconName } from "@/components";
import type { BasketStatus } from "../api";

const LOOK: Record<BasketStatus, { label: string; tone: BadgeTone; icon: IconName }> = {
  draft: { label: "Draft", tone: "neutral", icon: "pencil" },
  planned: { label: "Planned", tone: "info", icon: "check" },
  ordered: { label: "Ordered", tone: "success", icon: "truck" },
  archived: { label: "Archived", tone: "neutral", icon: "box" },
};

export function BasketStatusBadge({ status }: { status: BasketStatus }) {
  const look = LOOK[status];
  return (
    <Badge tone={look.tone} icon={look.icon}>
      {look.label}
    </Badge>
  );
}
